"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const is_prop_valid_1 = __importDefault(require("@emotion/is-prop-valid"));
const styled_1 = __importDefault(require("@emotion/styled"));
const ChildrenWrapper = (0, styled_1.default)('div', {
    shouldForwardProp: (prop) => (0, is_prop_valid_1.default)(prop) && prop !== 'orientation'
})({
    display: 'inline-block'
}, ({ orientation }) => ({
    ...(orientation === 'horizontal' && {
        paddingLeft: 10,
        paddingRight: 10
    }),
    ...(orientation === 'vertical' && {
        paddingTop: 10,
        paddingBottom: 10
    })
}));
exports.default = ChildrenWrapper;
//# sourceMappingURL=ChildrenWrapper.js.map